/* eslint-disable react/jsx-indent */

/* eslint-disable react/jsx-no-useless-fragment */

/* eslint-disable prefer-const */

/* eslint-disable react/destructuring-assignment */

/* eslint-disable no-unused-vars */

/* eslint-disable max-len */

/* eslint-disable indent */

/* eslint-disable consistent-return */
import { useEffect, useState } from 'react';

function CountdownTimer(props) {
  let expiresInSec = props.expiresIn + 60;
  // expiresInSec = 60 * 60 * 2;
  const [min, setMin] = useState(0);
  const [sec, setSec] = useState(0);
  const [hr, setHr] = useState(0);
  const [timeLeft, setTimeLeft] = useState(0);
  const [timeOverFlag, setTimeOverFlag] = useState(false);

  const formatTime = (t) => (t < 10 ? `0${t}` : t);

  useEffect(() => {
    setTimeLeft(expiresInSec);
  }, [props.name]);

  useEffect(() => {
    const interval = setInterval(() => {
      const h = Math.floor(timeLeft / 3600);
      const m = Math.floor((timeLeft - h * 60 * 60) / 60);
      const s = timeLeft - m * 60 - h * 60 * 60;

      setMin(m);

      setSec(s);
      setHr(h);
      if (h === 0 && m === 0 && s === 0) {
        setTimeOverFlag(true);
      }
      if (h <= 0 && m <= 0 && s <= 0) return () => clearInterval(interval);

      setTimeLeft((t) => t - 1);
    }, 1000);

    return () => clearInterval(interval);
  }, [timeLeft]);

  useEffect(() => {
    if (timeOverFlag) {
      props.setTimeOverFlagFun(true);
    }
  }, [timeOverFlag]);

  const fmtTimerStr = (minutes, seconds) => {
    const str = `${minutes} min${minutes > 1 ? 's' : ''} ${seconds} sec`;
    return str;
  };
  const fmtTimerStrEndsIn = (hours, minutes, seconds) => {
    let str = `${hours} hr${hours > 1 ? 's' : ''} ${minutes} min${minutes > 1 ? 's' : ''}`;
    if (hours === '00' || hours === 0) {
      str = `${minutes} min${minutes > 1 ? 's' : ''} ${seconds} sec`;
    }
    return str;
  };

  return (
    <>
      {props.name === 'startsIn'
        ? fmtTimerStr(formatTime(min), formatTime(sec))
        : fmtTimerStrEndsIn(formatTime(hr), formatTime(min), formatTime(sec))}
    </>
  );
}

export default CountdownTimer;
